import { render, staticRenderFns } from "./GenderDistributionGraph.vue?vue&type=template&id=4c8aae62"
import script from "./GenderDistributionGraph.vue?vue&type=script&lang=js"
export * from "./GenderDistributionGraph.vue?vue&type=script&lang=js"
import style0 from "./GenderDistributionGraph.vue?vue&type=style&index=0&id=4c8aae62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports